import styled from "@emotion/styled"
import { css, keyframes } from '@emotion/react'
import facepaint from "facepaint"

import StandardSection from '../c/StandardSection/StandardSection'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const wrapMQ = css(mq({
  paddingTop: [
    56, // 0+
    56, // 440+
    64, // 768+
    80, // 1024+
    80, // 1200+
    150, // 1400+
  ],
}))

export const Wrap = styled(StandardSection)`
  ${wrapMQ}
`

const contentMQ = css(mq({
  gap: [
    32, // 0+
    32, // 440+
    32, // 768+
    32, // 1024+
    48, // 1200+
    88, // 1400+
  ],
}))

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  ${contentMQ}
`

export const TitleWrap = styled.div`
  max-width: 620px;
`

const titleMQ = css(mq({
  font: [
    "var(--accent-770)", // 0+
    "var(--accent-770)", // 440+
    "var(--accent-970)", // 768+
    "var(--accent-1070)", // 1024+
  ],
}))

export const Title = styled.h2`
  color: var(--color-grayscale-900);

  & > ins {
    color: var(--color-indigo-400);
    text-decoration: none;
  }
  ${titleMQ}
`

const featuresWrapMQ = css(mq({
  gridTemplateColumns: [
    "auto", // 0+
    "auto", // 440+
    "auto", // 768+
    "auto", // 1024+
    "1fr 59%", // 1200+
    "1fr 63%", // 1400+
  ],
  gap: [
    0, // 0+
    0, // 440+
    0, // 768+
    0, // 1024+
    36, // 1200+
    68, // 1400+
  ],
}))

export const FeaturesWrap = styled.div`
  display: grid;
  align-items: start;
  ${featuresWrapMQ}
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.10) inset;
`

const activeItem = ({ isActive }) => (
  css({
    gridTemplateRows: isActive ? "1fr" : "0fr",
  })
)

export const Item = styled.div`
  will-change: grid-template-rows;
  display: grid;
  grid-template-columns: 100%;
  transition: grid-template-rows .4s ease-in-out;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.10) inset;
  ${activeItem}
`

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 56px;
  overflow: hidden;
`

const activeItemButton = ({ isActive }) => {
  if (isActive) {
    return css({
      color: "var(--color-grayscale-900)",

      "& > svg": {
        color: "var(--color-indigo-400)",
      }
    })
  }
}

export const ItemButton = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  font: var(--accent-570);
  color: var(--color-grayscale-300);
  padding: 14px 0;
  text-align: left;
  white-space: nowrap;
  transition: color var(--fast-transition);

  &:hover {
    color: var(--color-grayscale-900);
  }

  & > svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }

  ${activeItemButton}
`

export const ItemText = styled.div`
  font: var(--text-540);
  color: var(--color-grayscale-900);
  margin-top: -6px;
  margin-bottom: 24px;
  max-width: 560px;
`

const itemImageWrapMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
    "flex", // 1024+
    "none", // 1200+
    "none", // 1400+
  ],
}))

export const ItemImageWrap = styled.div`
  margin: -6px 0 24px;
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(89deg, #B56BCC -2.74%, #CDA4FE 86.27%);
  flex-shrink: 0;
  align-self: start;

  & > img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
  }
  ${itemImageWrapMQ}
`

const imageWrapMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "flex", // 1200+
    "flex", // 1400+
  ],
}))

export const ImageWrap = styled.div`
  display: flex;
  padding: 16px;
  border-radius: 20px;
  background: linear-gradient(89deg, #B56BCC -2.74%, #CDA4FE 86.27%);

  & > img {
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    opacity: 0;
    animation: ${fadeIn} 0.6s forwards ease;
  }
  ${imageWrapMQ}
`
